<header class="zag-card__header" [class.zag-card__header--labelled]="hasLabel()">
  @if (hasLabelRow()) {
  <div class="zag-card__label-row">
    @if (hasLabel()) {
    <div class="zag-card__label" role="heading" [attr.aria-level]="labelLevel()">{{ label() }}</div>
    }
    <ng-content select="[zagCardHeaderEnd]"></ng-content>
  </div>
  }
  <ng-content select="[card-header]"></ng-content>
</header>

<div class="zag-card__body">
  <ng-content></ng-content>
</div>

<footer class="zag-card__footer">
  <ng-content select="[card-footer]"></ng-content>
</footer>
